import PublicHeader from "../components/PublicHeader";
import "./css/About.css";
import { FaBolt, FaUsers, FaUtensils, FaCheckCircle, FaClock } from "react-icons/fa";

export default function AboutPage() {
  return (
    <div className="about-page">
      <PublicHeader />

      {/* HERO */}
      <section className="about-hero">
        <h1>O MesaClick nasceu para transformar a operação dos restaurantes</h1>
        <p>
          Uma plataforma moderna, rápida e intuitiva criada para agilizar pedidos,
          organizar o salão e oferecer a melhor experiência para o cliente.
        </p>
      </section>

      {/* BLOCO PRINCIPAL */}
      <section className="about-content-section">
        <div className="about-content-card">

          <h2>O que é o MesaClick?</h2>
          <p>
            O MesaClick é uma solução completa de autoatendimento e gestão operacional,
            desenvolvida pela <strong>Faenetech Sistemas e Tecnologia</strong> para trazer
            eficiência, velocidade e organização para restaurantes de todos os tamanhos.
          </p>

          {/* MISSÃO */}
          <div className="about-feature">
            <FaBolt className="feat-icon" />
            <div>
              <h3>Nossa Missão</h3>
              <p>
                Ajudar restaurantes a operar com mais produtividade, reduzindo erros e agilizando
                a comunicação entre salão e cozinha — sem complicações.
              </p>
            </div>
          </div>

          {/* POR QUE EXISTE */}
          <h2>Por que o MesaClick existe?</h2>

          <div className="about-grid">
            <div className="grid-item">
              <FaClock className="grid-icon" />
              <p>Reduzir atrasos e filas no atendimento</p>
            </div>

            <div className="grid-item">
              <FaCheckCircle className="grid-icon" />
              <p>Diminuir erros de pedido e retrabalho</p>
            </div>

            <div className="grid-item">
              <FaUtensils className="grid-icon" />
              <p>Agilizar o fluxo da cozinha com KDS</p>
            </div>

            <div className="grid-item">
              <FaUsers className="grid-icon" />
              <p>Melhorar a experiência do cliente</p>
            </div>
          </div>

          {/* DIFERENCIAIS */}
          <h2>Diferenciais da plataforma</h2>

          <ul className="about-list">
            <li>✔ Mesas ilimitadas</li>
            <li>✔ KDS completo incluso</li>
            <li>✔ Gestão de salão em tempo real</li>
            <li>✔ Relatórios e indicadores visuais</li>
            <li>✔ Multi-restaurantes</li>
            <li>✔ Suporte via WhatsApp</li>
            <li>✔ Atualizações constantes</li>
          </ul>
        </div>
      </section>

      <footer className="about-footer">
        © {new Date().getFullYear()} MesaClick — By Faenetech Sistemas e Tecnologia
      </footer>
    </div>
  );
}
